module.exports = __webpack_public_path__ + "static/media/logo1.fa56be91.png";